import React, { lazy } from "react";

// Libraries
import { Col, Container, Navbar, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Parallax } from "react-scroll-parallax";
import { m } from "framer-motion";
import { Link as ScrollTo } from "react-scroll";
import AddFranchise from "../../Components/Modal/add-franchise";

// Components
import {
  Header,
  HeaderNav,
  Menu,
  SearchBar,
} from "../../Components/Header/Header";
import { fadeIn, fadeInLeft, zoomIn } from "../../Functions/GlobalAnimations";
import Buttons from "../../Components/Button/Buttons";

// Data

import ProcessStep from "../../Components/ProcessStep/ProcessStep";
import { ProcessStepData01 } from "../../Components/ProcessStep/ProcessStepData";
import PortfolioSwitchImg from "../../Components/Portfolio/PortfolioSwitchImg";
import {
  FilterData,
  portfolioClassicData,
  portfolioColorfulData,
  portfolioSwitchImgData,
} from "../../Components/Portfolio/PortfolioData";
import PortfolioColorful from "../../Components/Portfolio/PortfolioColorful";
import PortfolioJustifiedGallery from "../../Components/Portfolio/PortfolioJustifiedGallery";

const IconWithText = lazy(
  () => import("../../Components/IconWithText/IconWithText"),
);

const TabData = [
  {
    tabTitle: "01. PLANNING",
    subtitle: "Unlimited power customization",
    title: "We offer a full range of digital marketing services",
    img: "https://via.placeholder.com/800x717",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    buttonTitle: "Discover Litho",
    buttonLink: "#",
  },
  {
    tabTitle: "02. RESEARCH",
    subtitle: "Powerful theme for creative designer",
    title: "We are expert in search engine and social media",
    img: "https://via.placeholder.com/800x717",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    buttonTitle: "Discover Litho",
    buttonLink: "#",
  },
  {
    tabTitle: "03. TARGET",
    subtitle: " Unlimited power customization",
    title: "We created digital ideas that are bigger and bolder",
    img: "https://via.placeholder.com/800x717",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    buttonTitle: "Discover Litho",
    buttonLink: "#",
  },
  {
    tabTitle: "04. CAMPAIGN",
    subtitle: "Browse amazing social media features",
    title: "Litho is meant to simplify the website building",
    img: "https://via.placeholder.com/800x717",
    content:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit do eiusmod tempor incididunt ut labore et dolore magna ut enim ad minim veniam nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    buttonTitle: "Discover Litho",
    buttonLink: "#",
  },
];

const IconWithTextData = [
  {
    title: "Strong Support System",
    content: "Training, marketing, and supply chain assistance.",
    icon: "line-icon-Navigation-LeftWindow text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
  {
    title: "Proven Brand",
    content: "Serving chai lovers since 2017",
    icon: "line-icon-Cursor-Click2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
  {
    title: "Low Investment, High Returns",
    content: "Affordable franchise packages with quick ROI",
    icon: "line-icon-Like-2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
  {
    title: "Community-Centric",
    content: "We don’t just build businesses, we build chai communities",
    icon: "line-icon-Talk-Man text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
  {
    title: "Popular Product",
    content: "RangeAuthentic chai blends, snacks, and café menu customers love",
    icon: "line-icon-Heart text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
  {
    title: "Marketing & Branding Support",
    content:
      "Centralized campaigns, social media promotions & local marketing guidance",
    icon: "line-icon-Gear-2 text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] via[#f767a6] to-[#ff798e]",
  },
];

const WhatWeOfferPage = (props) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <div style={props.style}>
        {/* Header Start */}
        <Header
          topSpace={{ dekstop: false, md: true }}
          type="reverse-scroll"
          className="w-[calc(100%-80px)] left-10 top-[30px] bg-white/5 rounded-[40px] backdrop-blur-md"
        >
          <HeaderNav
            fluid="fluid"
            theme="dark"
            expand="lg"
            className="px-[35px] py-[0px] md:pr-[15px] sm:pr-0 md:pl-0 md:py-[14px]"
          >
            <Col lg={2} sm={6} className="col-auto me-auto ps-lg-0 sm:!pl-0">
              <Link
                aria-label="header home link"
                className="flex items-center"
                to="/"
              >
                <Navbar.Brand className="inline-block p-0 m-0">
                  <img
                    className="default-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-white@2x.webp"
                    alt="logo"
                  />
                  <img
                    className="alt-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-black@2x.webp"
                    alt="logo"
                  />
                  <img
                    className="mobile-logo"
                    width="111"
                    // height="36"
                    loading="lazy"
                    src="/assets/img/banner/logo-wt.png"
                    data-rjs="/assets/img/webp/logo-golden-black@2x.webp"
                    alt="logo"
                  />
                </Navbar.Brand>
              </Link>
            </Col>
            <Navbar.Toggle className="order-last md:ml-[25px] sm:ml-[17px]">
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
              <span className="navbar-toggler-line"></span>
            </Navbar.Toggle>
            <Navbar.Collapse className="col-auto justify-center menu-order px-lg-0 restaurant-header-menu">
              <Menu {...props} />
            </Navbar.Collapse>
            <Col className="col-auto col-lg-2 text-right pe-0 font-size-0 ">
              <Buttons
                onClick={() => setOpen(true)}
                type="button"
                className="px-[20px] py-[10px] btn-fill font-medium font-serif rounded-[10px] uppercase md:mb-0 bg-gradient-to-r from-red-500 to-red-600 text-white"
                // themeColor="bg-gradient-to-r from-red-500 to-red-600"
                // color="white"
                size="sm"
                title="Be a Franchise"
              />
              {/* </ScrollTo> */}
            </Col>
          </HeaderNav>
        </Header>
        {/* Header End */}

        {/* Parallax Scrolling Start */}
        <div className="h-[660px] lg:h-[580px] md:h-[550px] sm:h-[500px] xs:h-[380px] flex items-center overflow-hidden relative">
          <Parallax
            className="lg-no-parallax bg-cover cover-background absolute top-[0px] left-0 w-full h-[100vh]"
            translateY={[-40, 40]}
            style={{
              // backgroundImage: `url(https://via.placeholder.com/1920x1100)`,
              backgroundImage: `url(https://res.cloudinary.com/duk4olh1p/image/upload/v1758806230/abc6_ufyvaz.webp)`,
            }}
          ></Parallax>
          <div className="absolute h-full w-full opacity-50 top-0 left-0 bg-darkgray"></div>
          <Container>
            <Row className="items-center justify-center">
              <Col md={8} xl={6} lg={7} sm={9} className="relative text-center">
                <h1 className="inline-block text-white opacity-60 mb-[20px] text-xmd leading-[20px] -tracking-[.5px] font-serif">
                  From Chai Lovers to Chaipreneurs
                </h1>
                <h2 className="font-serif text-white -tracking-[1px] text-[2.9rem] font-medium mb-0 sm:-tracking-[1px]">
                  Your Franchise, Our Chai Legacy
                </h2>
              </Col>
              <ScrollTo
                to="about"
                offset={0}
                delay={0}
                spy={true}
                smooth={true}
                duration={800}
                className="absolute bottom-[50px] left-1/2 w-auto inline-block p-0 -translate-x-1/2 sm:bottom-7 xs:bottom-[4.5rem] cursor-pointer"
              >
                <i className="ti-arrow-down text-lg leading-[1] text-white bg-[#000000b3] p-[15px] xs:p-[10px] rounded-full flex justify-center items-center"></i>
              </ScrollTo>
            </Row>
          </Container>
        </div>
        {/* Parallax Scrolling End */}

        {/* Section Start */}
        <m.section
          id="about"
          className="py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] overflow-hidden"
          {...fadeIn}
        >
          <Container>
            <Row className="items-center">
              <Col md={6} className="relative sm:mb-[30px]">
                <img
                  // src="https://via.placeholder.com/800x553"
                  src="https://res.cloudinary.com/duk4olh1p/image/upload/v1760157650/trusted_cfxk0w.webp"
                  className="rounded-[5px] w-full"
                  height="364"
                  width="190"
                  alt="what-we-offers"
                />
                {/* Modal Component Start */}
                {/* <CustomModal.Wrapper
                  className="absolute top-0 left-0 w-full h-full flex items-center justify-center"
                  modalBtn={
                    <Buttons
                      type="submit"
                      className="btn-sonar border-0"
                      themeColor={["#b27cfd", "#ff9393"]}
                      color="#fff"
                      size="lg"
                      title={<i className="icon-control-play" />}
                    />
                  }
                >
                  <div className="w-[1020px] max-w-full relative rounded mx-auto">
                    <div className="fit-video">
                      <iframe
                        width="100%"
                        height="100%"
                        className="shadow-[0_0_8px_rgba(0,0,0,0.06)]"
                        controls
                        src="https://www.youtube.com/"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </CustomModal.Wrapper> */}
                {/* Modal Component End */}
              </Col>
              <Col lg={{ span: 5, offset: 1 }} md={6}>
                <h5 className="font-serif font-medium text-darkgray w-[90%]">
                  Become a Franchise Partner
                </h5>
                <p className="w-[85%] mb-[25px] lg:w-[90%]">
                  At Mukhiya Ji Chai, we don’t just sell tea, we create
                  opportunities. With our proven business model, affordable
                  investment plans, and strong brand identity, we help aspiring
                  entrepreneurs start their own profitable chai café. From
                  franchise setup, training, product supply, marketing, and
                  ongoing support, we make your journey smooth and rewarding.
                </p>
                <p className="w-[85%] mb-[25px] lg:w-[90%]">
                  <span className="font-semibold text-darkgray">
                    Join our family and brew success, one cup at a time.
                  </span>
                </p>
                <div className="mt-[15px] sm:mt-0 inline-block">
                  {/* <Buttons
                    to="/page/who-we-are"
                    className="mr-[24px] font-medium rounded-none font-serif uppercase hover:text-darkgray btn-slide-filling-right bg-gradient-to-r from-darkgray to-darkgray sm:mr-[20px] xs:mr-[8px]"
                    size="md"
                    color="#fff"
                    themeColor="#fff"
                    title="Discover Litho"
                  />
                  <Buttons
                    to="/page/about-us"
                    className="font-medium rounded-none font-serif uppercase hover:text-white bg-transparent btn-slide-right"
                    size="md"
                    color="#232323"
                    themeColor="#232323"
                    title="Read more"
                  /> */}
                </div>
              </Col>
            </Row>
          </Container>
        </m.section>
        {/* Section End */}

        {/* Section Start */}
        <section className="py-[130px] bg-lightgray lg:py-[90px] md:py-[75px] sm:py-[50px] overflow-hidden">
          <Container>
            <Row className="justify-center">
              <Col
                xl={5}
                sm={8}
                className="text-center mb-24 font-serif sm:mb-12"
              >
                <span className="text-xmd mb-[20px] block text-red font-medium">
                  Start Your Own Chai Café with Mukhiya Ji Chai
                </span>
                <h5 className="text-darkgray font-medium inline-block">
                  Easy Step Process to Get a Franchise
                </h5>
              </Col>
              <ProcessStep
                grid="row-cols-1 row-cols-lg-4 row-cols-sm-2 gap-y-10"
                theme="process-step-style-01"
                className=""
                data={ProcessStepData01}
                animation={fadeIn}
              />
            </Row>
            {/* <Row>
              <Col className="text-center mt-24 lg:mt-16 md:mt-[35px] xs:mt-[60px]">
                <Buttons
                  onClick={() => setOpen(true)}
                  // href="/page/contact-us-modern"
                  className="btn-fill shadow-md font-medium font-serif uppercase rounded-none btn-shadow !tracking-[0px]"
                  size="lg"
                  themeColor="red"
                  color="white"
                  title="Get started now"
                />
              </Col>
            </Row> */}
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <m.section className="ourservice-pricingtable" {...fadeIn}>
          {/* <Container>
            <Row className="justify-center">
              <Col md={6} className="font-serif text-center mb-20 sm:mb-12">
                <span
                  className="mb-[10px] inline-block uppercase font-medium 
                // text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e] 
                tracking-[1px]"
                >
                  Simple Pricing
                </span>
                <h5 className="text-darkgray font-semibold -tracking-[1px]">
                  Amazing Package
                </h5>
              </Col>
            </Row>
            <PricingTable04
              grid="row-cols-1 row-cols-lg-3 gap-y-[30px] justify-center items-center"
              theme="pricing-table-style-04 col-12 col-lg-4 col-md-7"
              className=""
              data={pricingTable04}
            />
          </Container> */}
        </m.section>
        {/* Section End */}

        {/* Section Start */}
        <section className="py-[80px] lg:py-[85px] md:py-[65px] sm:py-[50px] xs:px-[15px] bg-lightgray">
          <Container>
            <Row className="justify-center">
              <Col
                xl={5}
                sm={8}
                className="text-center mb-20 font-serif sm:mb-12"
              >
                {/* <span className="text-xmd mb-[20px] block text-red font-medium">
                  Short Title here
                </span> */}
                <h5 className="text-darkgray font-medium inline-block">
                  Why Choose Mukhiya Ji Chai
                </h5>
              </Col>
            </Row>
            <IconWithText
              grid="row-cols-1 row-cols-lg-3 row-cols-sm-2"
              theme="icon-with-text-10"
              data={IconWithTextData}
              animation={fadeIn}
              animationDelay={0.1}
            />
          </Container>
          <Row className="justify-center gx-0">
            <Col className="text-center mt-24 lg:mt-16 md:mt-[35px] xs:mt-[60px]">
              <Buttons
                onClick={() => setOpen(true)}
                // href="/page/contact-us-modern"
                className="btn-fill text-white bg-[#dc2626] shadow-md font-medium font-serif uppercase rounded-none btn-shadow !tracking-[0px]"
                size="lg"
                themeColor="#dc2626"
                color="white"
                title="Get started now"
              />
            </Col>
          </Row>
        </section>
        {/* Section End */}

        {/* Image Gallery Section Start  */}

        {/* Section Start */}
        <section className="py-[50px] bg-lightgray overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
          <Row className="justify-center">
            <Col xl={5} sm={8} className="text-center font-serif">
              {/* <span className="text-xmd mb-[20px] block text-red font-medium">
                  Short Title here
                </span> */}
              <h5 className="text-darkgray font-medium inline-block">
                Franchise Gallery
              </h5>
            </Col>
          </Row>
          <Container fluid className="px-[9.5rem] xl:px-0">
            <Row className="justify-center">
              <Col xl={11} className="mt-[10.5rem] xs:mt-12">
                <PortfolioJustifiedGallery
                  filter={false}
                  grid="grid grid-3col xl-grid-4col lg-grid-3col md-grid-2col sm-grid-2col xs-grid-1col gutter-extra-large"
                  data={portfolioClassicData}
                />
              </Col>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Image Gallery Section End  */}

        {/* Section Start */}
        <section className="py-[160px] overflow-hidden lg:py-[120px] md:py-[95px] sm:py-[80px]">
          <Container>
            <Row lg={4} sm={2} xs={1}>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  H.O Address
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  J.M Road, Near Gruenanak School Bhandup (W), Mumbai 78
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  C.O Address
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  Mukhiya Ji Chai, Jari Mari Kurla (W), Mumbai 400072
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.2 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-map-pin text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  Sales Office
                </div>
                <p className="w-[75%] lg:w-full md:w-[60%] sm:w-[75%] mx-auto">
                  Mohalla Afghanan, Near Peer ki Chungi, Dhampur Road Nehtaur,
                  Distt- Bijnor (U.P) 246733
                </p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.4 } }}
                className="text-center md:mb-[40px]"
              >
                <i className="feather-phone-call text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px]">
                  Let's Talk
                </div>
                <p className="w-[70%] lg:w-full mx-auto">+91 7300863123</p>
                <p className="w-[70%] lg:w-full mx-auto">+91 9359059640</p>
              </m.div>
              <m.div
                {...{ ...fadeIn, transition: { delay: 0.6 } }}
                className="text-center xs:mb-[40px]"
              >
                <i className="feather-mail text-[28px] text-[#ea1d24] mb-[25px] sm:mb-[10px] block"></i>
                <div className="text-darkgray uppercase text-md font-semibold font-serif tracking-[1px] mb-[10px] sm:mb-0">
                  General Support
                </div>
                <p className="w-[70%] lg:w-full mx-auto">
                  <a
                    aria-label="gmail link"
                    rel="noreferrer"
                    href="mailto:info@mukhiyajichai.com"
                    className="hover:text-[#ea1d24]"
                  >
                    mukhiyajichai@gmail.com
                  </a>
                  {/* <br />
                <a
                  aria-label="gmail link"
                  rel="noreferrer"
                  href="mailto:hr@yourdomain.com"
                  className="hover:text-[#ea1d24]"
                >
                  support@mukhiyajichai.com
                </a> */}
                </p>
              </m.div>
            </Row>
          </Container>
        </section>
        {/* Section End */}

        {/* Section Start */}
        <section className="overflow-visible relative py-0">
          <ScrollTo
            href="#"
            to="parallax-section"
            offset={0}
            delay={0}
            spy={true}
            smooth={true}
            duration={800}
            className="left-1/2 top-1/2 absolute -translate-x-1/2 z-[1] -translate-y-1/2 cursor-pointer"
          >
            <m.img
              {...{ ...zoomIn, transition: { duration: 0.8 } }}
              width={198}
              height={197}
              className="w-[auto] md:w-[150px] sm:w-[100px]"
              src="https://lithoreact.themezaa.com/assets/img/webp/home-restaurant-img-transparent-07.webp"
              // src="/assets/img/banner/logo-wt.png"
              alt="restaurant"
            />
          </ScrollTo>
        </section>
        {/* Section Start */}

        {/* Footer Start */}
        <footer className="text-[#828282] py-[60px] border-t border-mediumgray md:pt-[80px] md:pb-[60px]">
          <Container>
            <Row className="items-center">
              <Col md={6} className="sm:mb-[15px]">
                <ul className="flex text-sm font-serif text-center justify-start md:justify-start sm:justify-center xs:text-center xs:flex-col">
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="about link"
                      to="/about-us"
                      className="hover:text-[#ea1d24]"
                    >
                      ABOUT US
                    </Link>
                  </li>
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="menu link"
                      to="/franchise"
                      className="hover:text-[#ea1d24]"
                    >
                      FRANCHISE
                    </Link>
                  </li>
                  <li className="nav-item mr-[35px] md:mr-[20px] xs:mr-0 xs:mb-[7px]">
                    <Link
                      aria-label="gallery link"
                      to="/products"
                      className="hover:text-[#ea1d24]"
                    >
                      OUR PRODUCTS
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      aria-label="contact link"
                      to="/contact-us"
                      className="hover:text-[#ea1d24]"
                    >
                      CONTACT
                    </Link>
                  </li>
                </ul>
              </Col>
              <Col md={6} className="text-right sm:text-center">
                <p className="text-sm uppercase flex items-center justify-end sm:justify-center">
                  © {new Date().getFullYear()} Mukhiya Ji Chai is Developed
                  by&nbsp;
                  <Buttons
                    target="_blank"
                    href="https://www.fluxteck.com/"
                    aria-label="button"
                    className="font-semibold p-0 font-serif text-decoration-line-bottom uppercase btn-link md:text-md hover:text-[#828282] !text-sm landscape:md:!leading-[18px]"
                    color="#000"
                    title="FluxTeck"
                  />
                </p>
              </Col>
            </Row>
          </Container>
        </footer>
        {/* Footer End */}
      </div>
      <AddFranchise open={open} setOpen={setOpen} />
    </>
  );
};

export default WhatWeOfferPage;
